import { IconName, NonIdealState } from "@blueprintjs/core";
import styled from "styled-components";
import { FlexDirection } from "./box";
type Props = {
  title?: string;
  icon?: IconName;
  iconDisable?: boolean;
  description?: string;
  descriptionDisable?: boolean;
  flexDir?: FlexDirection;
  translateY?: number;
};
const NotData = ({
  title,
  icon,
  iconDisable = true,
  description,
  descriptionDisable = true,
  flexDir,
  translateY = 20,
}: Props) => {
  return (
    <StyledWrapper flexDir={flexDir} translateY={translateY}>
      <NonIdealState
        title={title || "No Data found"}
        icon={iconDisable && (icon || "small-info-sign")}
        description={
          descriptionDisable &&
          (description || "Refine the filter to retrieve accurate results.")
        }
        layout={flexDir === "row" ? "horizontal" : "vertical"}
      />
    </StyledWrapper>
  );
};

const StyledWrapper = styled.div<{ flexDir?: string, translateY: number }>`
  display: flex;
  flex-direction: ${({ flexDir }) => flexDir || "column"};
  justify-content: ${({ flexDir }) =>
    flexDir === "row" ? "flex-start" : "center"};
  transform: ${({ translateY }) => `translateY(${translateY}%)`};
`;


export default NotData;
